import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../baseClasses/BaseComponent';
import AccentPicker from '../AccentPicker';
import CheckBox from '../../../components/CheckBox';
import StateComboBox from '../../../components/StateComboBox';
import CountryComboBox from '../../../components/CountryComboBox';
import CompanyHeader from '../../../containers/CompaniesContainer/CompanyHeader';
import SelectUserComboBox from '../../../components/SelectUserComboBox';
import MarketComboBox from '../../../components/MarketComboBox';
import TabbedPageControl from '../../../components/TabbedPageControl';
import PhoneInput from '../../../components/PhoneInput';
import APIKeyWidget from '../../../components/APIKeyWidget';
import MultiFileUploader from '../../../components/MultiFileUploader';
import CompanyAddOns from './CompanyAddOns';

import FileUtil from '../../../helpers/FileUtil/FileUtil';
import userService from '../../../services/userService.js';
import dataModel from '../../../models/DataModel';
import './CompanyCRUD.scss';
import DataSource from '../../../dao/DataSource/DataSource';
import Input from '../../../components/Input/index.js';

import editIcon from '../../../assets/images/pencil-icon-gray.svg';
import deleteIcon from '../../../assets/images/trash.svg';
import IconButton from '../../../components/Buttons/IconButton';
export class CompanyCRUD extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      market: {},
      customer: {},
      updateMarket: {},
      updateCustomer: {},
      users: [],
      selectedTabName: 'COMPANY INFORMATION',
      editing: false,
      editCompany: null,
    };

    this.setCompanyAccent = this.setCompanyAccent.bind(this);
    this.setCompanyLogo = this.setCompanyLogo.bind(this);
    this.deleteCompanyLogo = this.deleteCompanyLogo.bind(this);
    this.isUserValid = this.isUserValid.bind(this);
    this.MAX_SIZE_MB = 1; // max file size 1MB
    this.MAX_SIZE_BYTES = this.MAX_SIZE_MB * 1024 * 1024;
  }

  handleCompanyChange(fetchedCompany, action) {
    if (fetchedCompany) {
      let makeSameChecked = false;
      if (fetchedCompany.admin && fetchedCompany.contact) {
        if (fetchedCompany.admin.id == fetchedCompany.contact.id) {
          makeSameChecked = true;
          fetchedCompany.admin.sameAsContact = true;
        }
      }
      // merge with fields that changed
      let editedCompany = null;
      let originalCompany = this.state.originalCompany;
      if (!originalCompany) {
        originalCompany = fetchedCompany;
        this.setState({ originalCompany });
      }
      if (this.state.editCompany) {
        editedCompany = {};
        let company = originalCompany;
        for (let key in fetchedCompany) {
          if (key == 'features') {
            editedCompany[key]= fetchedCompany[key];
          }
          else if (this.state.editing && !_.isEqual(company[key], this.state.editCompany[key])) {
            editedCompany[key] = this.state.editCompany[key];
          }
          else{
            editedCompany[key] = fetchedCompany[key];
          }
        }
      }
      if (editedCompany && editedCompany.admin && editedCompany.contact) {
        makeSameChecked = editedCompany.admin.id == editedCompany.contact.id;
        editedCompany.admin.sameAsContact = makeSameChecked;
      }
      this.setState({
        editCompany: editedCompany ? editedCompany : fetchedCompany, originalCompany: fetchedCompany, markets: fetchedCompany.markets, makeSameChecked,
        customers: fetchedCompany.customers, users: fetchedCompany.users, vendorUsers: fetchedCompany.vendor_users,
      });
    }
  }
  
  componentDidMount() {
    super.componentDidMount();

    if (this.props.company.is_vendor_company) {
      this.setState({ editCompany: this.props.company });
    }
    else {
      this.companyDataSource = new DataSource('Company', this.props.company, {
        company: {
          users: {},
          vendor_users: {}, directories: {},
          admin: { additionalFields: ['profile_image'] }, contact: { additionalFields: ['profile_image'] }, markets: {}, customers: {},
        },
      }, this.handleCompanyChange);
      this.companyDataSource.get();
    }

    this.tabs = ['COMPANY INFORMATION'];
    if (!this.props.readOnly && !this.props.company.admin_company) {
      this.tabs.push('COMPANY STRUCTURE', 'ADD-ONS');
    }

  }

  componentWillUnmount() {
    this.companyDataSource.release();
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate();
    if(this.newMarketCode && this.newMarketFocus){
      this.newMarketCode.focus(); 
      this.newMarketFocus = false;
    }
    else if (this.newCustomerCode && this.newCustomerFocus) {
      this.newCustomerCode.focus(); 
      this.newCustomerFocus = false;
    }
  }

  handleSelectTab(tabName) {
    this.setState({ selectedTabName: tabName });
  }

  handleClickOnUploadLogoInput() {
    // find a file input and click on it
    document.querySelector('.company-logo-container input[type="file"]').click();
  }

  setCompanyLogo(file, preview) {
    // this component depends on using a Data-URI for the logo,
    // thus preview is used instead of file (object)
    let editedCompany = this.copyCompany;
    editedCompany.logo = preview;
    editedCompany.logoUpdated = true;
    this.setState({
      editCompany: editedCompany,
      editing: true,
    });
  }

  deleteCompanyLogo() {
    this.setState({ displayLogoPopup: false }, () => this.setCompanyLogo(null, null));
  }

  get copyCompany() {
    let editedCompany = null;
    if (this.state.editCompany) {
      editedCompany = Object.assign({}, this.state.editCompany);
    }
    else {
      editedCompany = _.cloneDeep(this.props.company);
      this.setState({ originalCompany: this.props.company });
    }
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    if (!editedCompany.country) {
      editedCompany.country = 'United States';
    }
    if (!editedCompany.address_1) {
      editedCompany.address_1 = '';
    }
    if (!editedCompany.address_2) {
      editedCompany.address_2 = '';
    }
    if (!editedCompany.city) {
      editedCompany.city = '';
    }
    if (!editedCompany.state) {
      editedCompany.state = '';
    }
    return editedCompany;
  }

  setCompanyAccent(color) {
    let editedCompany = this.copyCompany;
    editedCompany.accent_color = color;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  get companyDirectory() {
    const { editCompany } = this.state;
    let companyDirectory = null;
    const directories = this.props.directories;
    if (directories) {
      for (let i = 0; i < directories.length; i++) {
        if (directories[i].company_id == editCompany.id) {
          companyDirectory = directories[i];
          break;
        }
      }
    }
    return companyDirectory;
  }

  handleSaveCompany() {
    let editedCompany = this.copyCompany;
    if (!editedCompany.name) {
      this.props.dataModel.displayInfoErrorMessage('The company must have a name.', 4000, 2);
    }
    else {
      editedCompany.name = editedCompany.name.trim();
      let companyDirectory = this.props.selectedDirectory;

      if (!companyDirectory) {
        companyDirectory = this.companyDirectory;
      }
      if (editedCompany.contact && editedCompany.contact.toBeDeleted) {
        editedCompany.contact = null;
      }
      else if (editedCompany.contact && !editedCompany.contact.id && editedCompany.contact.email && companyDirectory) {
        editedCompany.contact.company_id = editedCompany.id;
        editedCompany.contact.directory_id = companyDirectory.id;
        const contactRole = this.props.userRoles.filter(role => {
          return role.name == 'primary_contact';
        });
        editedCompany.contact.role = contactRole.length > 0 ? contactRole[0] : null;
      }
      if (editedCompany.admin && editedCompany.admin.toBeDeleted) {
        editedCompany.admin = null;
      }
      else if (editedCompany.admin && !editedCompany.admin.id && editedCompany.admin.email && companyDirectory) {
        editedCompany.admin.company_id = editedCompany.id;
        editedCompany.admin.directory_id = companyDirectory.id;
        const adminRole = this.props.userRoles.filter(role => {
          return role.name == 'admin';
        });
        editedCompany.admin.role = adminRole.length > 0 ? adminRole[0] : null;
      }
    
      this.setState({ editing: false });
      dataModel.companiesDAO.updateCompany(editedCompany).then(company => {
        if (this.props.handleCompanySaved) {
          this.props.handleCompanySaved(this.props.company);
        }
      }
      );
    }
  }

  handleCancel() {
    let { editCompany, originalCompany } = this.state;
    if (originalCompany.name && (!_.isEqual(editCompany.contact, originalCompany.contact) || !_.isEqual(editCompany.admin, originalCompany.admin))) {
      let contact = editCompany.contact;
      let admin = editCompany.admin;
      editCompany = _.cloneDeep(originalCompany);
      editCompany.contact = contact;
      editCompany.admin = admin;
      this.setState({ editCompany });
    }
    else {
      editCompany = _.cloneDeep(originalCompany);
    }
    const makeSameChecked = editCompany.admin && editCompany.contact && editCompany.admin.email == editCompany.contact.email ? true : false;
    this.setState({
      editCompany,
      editing: false,
      makeSameChecked,
      croppedFile: null,
    });
    if (this.props.handleCompanyEditDone) {
      this.props.handleCompanyEditDone(this.state.originalCompany);
    }
  }

  isUserValid(user) {
    return (user.first_name && user.last_name && user.email && user.markets && user.markets.length);
  }
  
  handleCompanyNameChange(e) {
    let editedCompany = this.copyCompany;
    editedCompany.name = e.target.value;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleContactFirstNameChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.first_name = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleContactLastNameChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.last_name = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleContactTitleChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.title = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleContactPhoneChange(phone) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.phone = phone;
    this.setState({ editCompany: editedCompany });
  }

  handleContactEmailChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.email = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleContactMarketsChange(markets) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.contact) {
      editedCompany.contact = {};
    }
    editedCompany.contact.markets = markets.filter(market => !market.toBeDeleted);
    this.setState({ editCompany: editedCompany });
  }

  handleAdminFirstNameChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.first_name = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleAdminLastNameChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.last_name = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleAdminTitleChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.title = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleAdminPhoneChange(phone) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.phone = phone;
    this.setState({ editCompany: editedCompany });
  }

  handleAdminEmailChange(e) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.email = e.target.value;
    this.setState({ editCompany: editedCompany });
  }

  handleAdminMarketsChange(markets) {
    let editedCompany = this.copyCompany;
    if (!editedCompany.admin) {
      editedCompany.admin = {};
    }
    editedCompany.admin.markets = markets.filter(market => !market.toBeDeleted);
    this.setState({ editCompany: editedCompany });
  }

  handleMakeAdminSameAsContact(checked) {
    let editedCompany = this.copyCompany;
    if (checked) {
      this.setState({ makeSameChecked: true });
      if (editedCompany.contact && editedCompany.contact.email &&!editedCompany.contact.toBeDeleted) {
        editedCompany.admin = Object.assign({}, editedCompany.contact);
      }
      else if (editedCompany.admin && editedCompany.admin.email && !editedCompany.admin.toBeDeleted) {
        editedCompany.contact = Object.assign({}, editedCompany.admin);
      }
      editedCompany.admin.sameAsContact = true;
    }
    else {
      this.setState({ makeSameChecked: false });
      if (editedCompany.admin) {
        editedCompany.admin.sameAsContact = false;
        editedCompany.admin.toBeDeleted = true;
      }
    }
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyAddress1Change(e) {
    let editedCompany = this.copyCompany;
    editedCompany.address_1 = e.target.value;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyAddress2Change(e) {
    let editedCompany = this.copyCompany;
    editedCompany.address_2 = e.target.value;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyCityChange(e) {
    let editedCompany = this.copyCompany;
    editedCompany.city = e.target.value;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyZipChange(e) {
    let editedCompany = this.copyCompany;
    editedCompany.zip = e.target.value;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyStateChange(state) {
    let editedCompany = this.copyCompany;
    editedCompany.state = state;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  handleCompanyCountryChange(country) {
    let editedCompany = this.copyCompany;
    editedCompany.country = country;
    this.setState({ editCompany: editedCompany, editing: true });
  }

  get newUser() {
    let directory = null;
    
    if (this.props.directories) {
      for (let i = 0; i < this.props.directories.length; i++) {
        directory = this.props.directories[i];
        break;
      }
    }

    return { first_name: '', last_name: '', title: '', email: '', directory: directory };
  }

  handleContactSelection(type, optionSelected) {
    let editedCompany = this.copyCompany;
    if (parseInt(type, 10) == -1) {
      if (editedCompany.contact.toBeDeleted) {
        delete editedCompany.contact.toBeDeleted;
      }
      editedCompany.contact = this.newUser;
      this.setState({ addContact: true, editCompany: editedCompany });
    }
    else {
      if (optionSelected.selected) {
        if (editedCompany.contact.toBeDeleted) {
          delete editedCompany.contact.toBeDeleted;
        }
        editedCompany.contact = optionSelected.user;
        if (editedCompany.admin && editedCompany.admin.sameAsContact) {
          editedCompany.admin = optionSelected.user;
        }
        this.setState({ editCompany: editedCompany, editing: true });
      }
      else {
        if (editedCompany.contact) {
          editedCompany.contact.toBeDeleted = true;
          if (editedCompany.admin && editedCompany.admin.sameAsContact) {
            delete editedCompany.admin.sameAsContact;
          }
          this.setState({ editCompany: editedCompany, editing: true, makeSameChecked: false });
        }
      }
    }
  }

  handleAdminSelection(type, optionSelected) {
    let editedCompany = this.copyCompany;
    if (parseInt(type, 10) == -1) {
      if (editedCompany.admin.toBeDeleted) {
        delete editedCompany.admin.toBeDeleted;
      }
      editedCompany.admin = this.newUser;
      this.setState({ addAdmin: true, editCompany: editedCompany });
    }
    else {
      if (optionSelected.selected) {
        if (editedCompany.admin.toBeDeleted) {
          delete editedCompany.admin.toBeDeleted;
        }
        editedCompany.admin = optionSelected.user;
        this.setState({ editCompany: editedCompany, editing: true });
      }  
      else {
        if (editedCompany.admin) {
          editedCompany.admin.toBeDeleted = true;
          this.setState({ editCompany: editedCompany, editing: true });
        }
      }
    }
  }

  handleAdminCallback(user){
    let editedCompany = this.copyCompany;
    editedCompany.admin = user;
    this.setState({ 
      editCompany: editedCompany,
    });
    this.handlePromptSendInvite(user);
  }

  handleContactCallback(user){
    let editedCompany = this.copyCompany;
    editedCompany.contact = user;
    this.setState({ 
      editCompany: editedCompany,
    });
    this.handlePromptSendInvite(user);
  }
  
  handlePromptSendInvite(user){
    this.setState({ displayPopup: false });
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      captionText: 'INVITE',
      type: 'info',
      message: this.textMap.promptSendInvite,
      cancelButtonText: 'Later',
      okButtonText: 'Now',
      width: 300,
      height: 175,
      handleOwnerOk: () => {
        dataModel.usersDAO.sendInvite(user);
      },
    });
  }

  handleCancelAddContact() {
    let editedCompany = this.copyCompany;
    editedCompany.contact = this.props.company.contact;
    this.setState({ 
      addContact: false, 
      editCompany: editedCompany,
    });
  }

  isEmailValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  handleAddContact() {
    const editedCompanyContact = this.state.editCompany.contact;
    // return if form is not valid
    const formValid = this.isUserValid(editedCompanyContact);
    if (!formValid) return;

    if(editedCompanyContact.email){
      let contact = this.state.editCompany.contact;
      let self = this;

      // validate email
      const emailValid = this.isEmailValid(editedCompanyContact.email);
      if (!emailValid) return self.props.dataModel.displayInfoErrorMessage('Invalid email format', 4000, 2);

      userService.checkEmailAvailability(contact.email).then(res => {
        if (res.message == 'email already exists') {
          self.props.dataModel.displayInfoErrorMessage('A user is already associated with this email.', 4000, 2);
        }
        else {

          contact.company_id = self.state.editCompany.id;
          let directory_id = null;
          if (self.state.editCompany.directories && self.state.editCompany.directories.length > 0) {
            directory_id = self.state.editCompany.directories[0].id ? self.state.editCompany.directories[0].id : self.state.editCompany.directories[0];
          }
          else if (self.props.company.directories && self.props.company.directories.length > 0) {
            directory_id = self.props.company.directories[0].id ? self.props.company.directories[0].id : self.props.company.directories[0];
          }
          contact.directory_id = directory_id;
          const contactRole = self.props.userRoles.filter(role => {
            return role.name == 'primary_contact';
          });
          contact.role = contactRole.length > 0 ? contactRole[0] : null;

          dataModel.usersDAO.createUser(contact).then(user => {
            let markets = contact.markets.map(market => market.market);
            dataModel.marketsDAO.addMarketUser(markets, user.id);
            // Add the newly created user to the state
            this.setState(prevState => ({
              users: [...prevState.users || [], user],
            }));
            self.handleContactCallback(user);
          });
          self.setState({ addContact: false });
        }
      });
    }
  }

  handleCancelAddAdmin() {
    let editedCompany = this.copyCompany;
    editedCompany.admin = this.props.company.admin;
    this.setState({ 
      addAdmin: false, 
      editCompany: editedCompany,
    });
  }

  handleAddAdmin() {
    const editedAdmin = this.state.editCompany.admin;
    // return if form is not valid
    const formValid = this.isUserValid(editedAdmin);
    if (!formValid) return;
    
    if(editedAdmin.email){
      let self = this;
      let admin = this.state.editCompany.admin;

      // validate email
      const emailValid = this.isEmailValid(editedAdmin.email);
      if (!emailValid) return self.props.dataModel.displayInfoErrorMessage('Invalid email format', 4000, 2);
      
      userService.checkEmailAvailability(admin.email).then(res => {
        if (res.message == 'email already exists') {
          self.props.dataModel.displayInfoErrorMessage('A user is already associated with self email.', 4000, 2);
        }
        else {
          let directory_id = null;
          if (self.state.editCompany.directories && self.state.editCompany.directories.length > 0) {
            directory_id = self.state.editCompany.directories[0].id ? self.state.editCompany.directories[0].id : self.state.editCompany.directories[0];
          }
          else if (self.props.company.directories && self.props.company.directories.length > 0) {
            directory_id = self.props.company.directories[0].id ? self.props.company.directories[0].id : self.props.company.directories[0];
          }
          admin.company_id = self.state.editCompany.id;
          admin.directory_id = directory_id;
          
          const adminRole = self.props.userRoles.filter(role => {
            return role.name == 'admin';
          });
          
          admin.role = adminRole.length > 0 ? adminRole[0] : null;

          dataModel.usersDAO.createUser(admin).then(user => {
            let markets = admin.markets.map(market => market.market);
            dataModel.marketsDAO.addMarketUser(markets, user.id);
            // add newly created admin to the state
            this.setState(prevState => ({
              users: [...prevState.users || [], user],
            }));
            self.handleAdminCallback(user);
          });
          let editedCompany = self.copyCompany;
          editedCompany.admin.sameAsContact = false;
          self.setState({
            addAdmin: false,
            editCompany: editedCompany,
            editing: true,
          });
        }
      });
    }
  }

  handleDeleteMarket(e){
    let id = parseInt(e.target.getAttribute('data-id'), 10);
    let marketFilter = this.state.markets.filter(market => {
      return market.id == id;
    });
    if (marketFilter.length == 1) {
      const market = marketFilter[0];
      dataModel.marketsDAO.deleteMarket(market).then(response => {
        if (response.error) {
          dataModel.showGlobalModal('SYSTEM_POPUP', {
            message: 'The Market ' + market.code + ' | ' + market.name + ' cannot be deleted because it is in use.',
            captionText: 'ERROR',
            width: 300,
            height: 184,
            okButtonText: 'OK',
            oneButton: true,
          });
        }
        else {
          dataModel.displayInfoErrorMessage('The Market has been successfully deleted.', 4000, 1);
          this.newMarketFocus = true;
          this.setState({ refresh: true });
        }
      });
    }
  }

  handleValidateMarket(market) {
    const marketsWithoutMarket = this.state.markets ? this.state.markets.filter(toFilterMarket => !market.id || market.id != toFilterMarket.id): [];
    const existingMarketCodes = marketsWithoutMarket.map(market => market.code);
    let message;
    if (market) {
      if (!market.name || market.name.trim() == '') {
        message = 'Market name cannot be blank';        
      }
      if (!market.code || market.code.trim() == '') {
        message = 'Market code cannot be blank';
      }
      if (existingMarketCodes.includes(market.code)) {
        message = 'Market code already exists';
      }
    }
    return message;
  }

  handleSaveMarket() {
    if (this.state.newMarket) {
      let validatedMessage = this.handleValidateMarket(this.state.newMarket);

      if (validatedMessage) {
        this.props.dataModel.displayInfoErrorMessage(validatedMessage, 4000, 2);
      }
      else {
        dataModel.marketsDAO.createMarket(this.state.newMarket).then(newMarket => {
          if (newMarket) {
            this.setState({
              newMarket: {},
              marketEdited: false,
              updateMarketEdited: false,
              updateMarket: {},
            });
            this.newMarketFocus = true;
          }
          else {
            this.newMarketCode.focus();
          }
    
        });
      }
    }
  }

  handleUpdateMarket(){
    if(this.state.updateMarket){
      let validatedMessage = this.handleValidateMarket(this.state.updateMarket);

      if(validatedMessage){
        this.props.dataModel.displayInfoErrorMessage(validatedMessage, 4000, 2);
      }
      else {
        dataModel.marketsDAO.updateMarket(this.state.updateMarket).then(updateMarket => {
          if(updateMarket){
            let markets = this.state.markets.map(m => {
              if (m.id == updateMarket.id) {
                return updateMarket;
              }
              else {
                return m;
              }
            });
            this.setState({
              newMarket: {},
              markets,
              marketEdited: false,
              updateMarketEdited: false,
              updateMarket: updateMarket,
            });
            this.newMarketFocus = true;
          }
          else{
            // error updating market
          }
        });
      }
    }
  }
  
  handleNewMarketCodeChange(e){
    let editMarket = Object.assign({}, this.state.newMarket, { code: e.target.value });
    this.setState({ 
      newMarket: editMarket,
      marketEdited: true,
    });
  }

  handleNewMarketNameChange(e){
    let editMarket = Object.assign({}, this.state.newMarket, { name: e.target.value });
    this.setState({ 
      newMarket: editMarket, 
      marketEdited: true,    
    });
  }

  handleUpdateMarketCodeChange(e){
    let editMarket = Object.assign({}, this.state.updateMarket, { code: e.target.value });
    this.setState({ 
      updateMarket: editMarket,
      updateMarketEdited: true,
    });
  }

  handleUpdateMarketNameChange(e){
    let editMarket = Object.assign({}, this.state.updateMarket, { name: e.target.value });
    this.setState({ 
      updateMarket: editMarket, 
      updateMarketEdited: true,    
    });
  }

  handleClearMarket(){
    this.setState({
      newMarket: {},
      marketEdited: false,
    });
  }

  handleClearUpdateMarket(){
    this.setState({
      updateMarket: {},
      updateMarketEdited: false,
    });
  }

  handleDeleteCustomer(e){
    let id = parseInt(e.target.getAttribute('data-id'), 10);
    let customer = this.state.customers.filter(customer => {
      return customer.id == id;
    });
    if (customer.length == 1) {
      const deletedCustomer = customer[0];
      this.props.dataModel.customersDAO.deleteCustomer(deletedCustomer.id).then((response) => {
        const customers = this.state.customers.filter(customer => customer.id != deletedCustomer.id);
        this.newCustomerFocus = true;
        this.setState({ customers });
      });
    }
  }

  handleValidateCustomer(customer) {
    let message;
    const customersWithoutCustomer = this.state.customers ? this.state.customers.filter(toFilterCustomer => !customer.id || customer.id != toFilterCustomer.id): [];
    const existingCustomerCodes = customersWithoutCustomer.map(customer => customer.code);
    const existingCustomerNames = customersWithoutCustomer.map(customer => customer.name);
    if (customer) {
      if (!customer.name || customer.name.trim() == '') {
        message = 'Customer name cannot be blank';        
      }
      if (!customer.code || customer.code.trim() == '') {
        message = 'Customer code cannot be blank';
      }
      if (existingCustomerCodes.includes(customer.code)) {
        message = 'Customer code already exists';
      }
      if (existingCustomerNames.includes(customer.name)) {
        message = 'Customer name already exists';
      }
    }
    return message;
  }

  handleSaveCustomer(){
    if (this.state.newCustomer) {
      let validatedMessage = this.handleValidateCustomer(this.state.newCustomer);

      if (validatedMessage) {
        this.props.dataModel.displayInfoErrorMessage(validatedMessage, 4000, 2);
      }
      else {
        this.props.dataModel.customersDAO.createCustomer(this.state.newCustomer).then((customer) => {
          const customers = [...this.state.customers];
          customers.push(customer);
          this.newCustomerFocus = true;
          this.setState({
            newCustomer: {},
            customerEdited: false,
            updateCustomerEdited: false,
            updateCustomer: {},
            customers,
          });
        })
        .catch((error) => {
          this.newCustomerCode.focus();
        });
      }
    }
  }

  handleUpdateCustomer(){
    if (this.state.updateCustomer) {
      let validatedMessage = this.handleValidateCustomer(this.state.updateCustomer);

      if (validatedMessage) {
        this.props.dataModel.displayInfoErrorMessage(validatedMessage, 4000, 2);
      }
      else {
        this.props.dataModel.customersDAO.updateCustomer(this.state.updateCustomer).then((customer) => {
          const updatedIndex = this.state.customers.findIndex(c => c.id == customer.id);
          this.state.customers.splice(updatedIndex, 1, customer);
          this.setState({
            newCustomer: {},
            customerEdited: false,
            updateCustomerEdited: false,
            updateCustomer: {},
          });
          this.newCustomerFocus = true;
        });
      }
    }
  }
  
  handleNewCustomerCodeChange(e){
    let editCustomer = Object.assign({}, this.state.newCustomer, { code: e.target.value });
    this.setState({ 
      newCustomer: editCustomer,
      customerEdited: true,
    });
  }

  handleNewCustomerNameChange(e){
    let editCustomer = Object.assign({}, this.state.newCustomer, { name: e.target.value });
    this.setState({ 
      newCustomer: editCustomer, 
      customerEdited: true,    
    });
  }

  handleUpdateCustomerCodeChange(e){
    let editCustomer = Object.assign({}, this.state.updateCustomer, { code: e.target.value });
    this.setState({ 
      updateCustomer: editCustomer,
      updateCustomerEdited: true,
    });
  }

  handleUpdateCustomerNameChange(e){
    let editCustomer = Object.assign({}, this.state.updateCustomer, { name: e.target.value });
    this.setState({ 
      updateCustomer: editCustomer, 
      updateCustomerEdited: true,    
    });
  }

  handleClearCustomer(){
    this.setState({
      newCustomer: {},
      customerEdited: false,
    });
  }

  handleClearUpdateCustomer(){
    this.setState({
      updateCustomer: {},
      updateCustomerEdited: false,
    });
  }

  handleSetFocusMarketCode(element) {
    if (element && this.focusElementMarketCode != element) {
      this.focusElementMarketCode = element;
      element.focus();
    }
  }

  handleSetFocusMarketName(element) {
    if (element && this.focusElementMarketName != element) {
      this.focusElementMarketName = element;
      element.focus();
    }
  }

  handleMarketFocus(e){
    let id = parseInt(e.target.getAttribute('data-id'), 10);

    if(this.state.updateMarketEdited){
      if(id != this.state.updateMarket.id){
        // let them know one has changed and need to save changes
      }
    }
    else{
      // get market
      let market = this.state.markets.filter(market => {
        return market.id == id;
      });
      if(market.length == 1 && market[0]){
        // put market to be updated into state
        if (!this.state.updateMarket || this.state.updateMarket.id != market[0].id) {
          this.setState({
            updateMarket: market[0],
            market: {},
            marketEdited: false,
          });
        }
      }
    }
  }

  handleSetFocusCustomerCode(element) {
    if (element && this.focusElementCustomerCode != element) {
      this.focusElementCustomerCode = element;
      element.focus();
    }
  }

  handleSetFocusCustomerName(element) {
    if (element && this.focusElementCustomerName != element) {
      this.focusElementCustomerName = element;
      element.focus();
    }
  }

  handleCustomerFocus(e){
    let id = parseInt(e.target.getAttribute('data-id'), 10);

    if(this.state.updateCustomerEdited){
      if(id != this.state.updateCustomer.id){
        // let them know one has changed and need to save changes
      }
    }
    else{
      // get customer
      let customer = this.state.customers.filter(customer => {
        return customer.id == id;
      });
      if(customer.length == 1){
        // put customer to be updated into state
        this.setState({
          updateCustomer: customer[0],
          customer: {},
          customerEdited: false,
        });
      }
    }
  }

  getChildrenUsers(directory, users) {
    if (directory.users) {
      for (let i = 0; i < directory.users.length; i++) {
        const user = directory.users[i];
        users.push(user);
      }
    }
    else if (directory.directories) {
      for (let i = 0; i < directory.directories.length; i++) {
        const subDirectory = directory.directories[i];
        this.getChildrenUsers(subDirectory, users);
      }
    }
  }

  createContactDisplay() {
    let editedCompany = this.copyCompany;
    let contactDisplay = null;
    if (this.state.addContact && !this.props.readOnly) {
      contactDisplay = <div className="contact-display-edit">
        <div className="entry-field">
          <div className="label">{this.textMap.firstName.toUpperCase()}</div>
          <Input className="field input-field"
            value={editedCompany.contact && editedCompany.contact.first_name ? editedCompany.contact.first_name : ''}
            onChange={this.handleContactFirstNameChange} />
        </div>
        <div className="entry-field">
          <div className="label">{this.textMap.lastName.toUpperCase()}</div>
          <Input className="field input-field"
            value={editedCompany.contact && editedCompany.contact.last_name ? editedCompany.contact.last_name : ''}
            onChange={this.handleContactLastNameChange} />
        </div>
        <div className="entry-field">
          <div className="label">{this.textMap.title.toUpperCase()}</div>
          <Input className="field input-field"
            value={editedCompany.contact ? editedCompany.contact.title : ''}
            onChange={this.handleContactTitleChange} />
        </div>
        <div className="entry-field">
          <div className="label">{this.textMap.phone.toUpperCase()}</div>
          <PhoneInput 
            classNameInput={'field input-field'}
            inputValue={editedCompany.contact && editedCompany.contact.phone ? editedCompany.contact.phone : ''}
            handlePhoneChange={this.handleContactPhoneChange}
          />
        </div>
        <div className="entry-field">
          <div className="label">{this.textMap.email.toUpperCase()}</div>
          <Input className="field input-field"
            value={editedCompany.contact && editedCompany.contact.email ? editedCompany.contact.email : ''}
            onChange={this.handleContactEmailChange} />
        </div>
        <div className="entry-field markets">
          <div className="label">{'MARKETS'}</div>
          <MarketComboBox 
            markets={this.state.markets} 
            height={26} 
            width={240} 
            hasBorder={false}
            multiSelect={true}                        
            defaultText={'None Selected'}
            handleSelectMarket={this.handleContactMarketsChange} 
            currentOption={editedCompany.contact ? editedCompany.contact.markets : null} 
          />
        </div>
        <div className="add-user-footer">
          <div className="cancel-button" onClick={this.handleCancelAddContact} />
          <div className={'add-button' + (this.isUserValid(editedCompany.contact) ? '' : ' add-button--disabled')} onClick={this.handleAddContact}>
            {this.textMap.add.toUpperCase()}
          </div>
        </div>
      </div>;
    }
    else if (editedCompany){
      let users = null;
      let usersList=null;
      if (editedCompany.is_vendor_company && !this.props.readOnly) {
        users = this.state.vendorUsers;
      }
      else if (this.state.users && !this.props.readOnly) {
        users = this.state.users.filter(user => {
          const companyMatch = user.companies ? user.companies.filter(
                     company => {
                       return company.id ? company.id == editedCompany.id : company == editedCompany.id;
                     }
                   ) : [];
          return companyMatch.length > 0;
        });
      }
      if(users){
        usersList=users.filter(function(user){
          return !user.suspended;
        });   
      }
      
      let currentContact = editedCompany.contact;
      if (currentContact.toBeDeleted) {
        currentContact = null;
      }
      contactDisplay = <div className="contact-display-edit">
        <div className="entry-field contact-picker">
          <div className="label">{this.textMap.companyContact.toUpperCase()}</div>
          <div className="field input-field">
            {!this.props.readOnly && 
              <SelectUserComboBox 
                id={'contactPicker'} 
                width={240} 
                height={26} 
                hasBorder={false} 
                multiSelect={false}
                handleSelection={this.handleContactSelection} 
                currentSelectedUser={currentContact}
                users={usersList} 
                allowAdd={true} 
                small={true}
              />
            }
            {this.props.readOnly && <div className="field entry-field">{currentContact ? currentContact.name : 'None Selected'}</div>}
          </div>
        </div>
        {
          (!this.props.readOnly || (this.props.readOnly && this.state.makeSameChecked)) &&
          <div className="make-same-checkbox">
            <div className="checkbox">
              <CheckBox key="contact-admin-checkbox" toggleCheckBox={this.handleMakeAdminSameAsContact}
                checked={this.state.makeSameChecked} />
            </div>
            <div className="caption">Use as Primary Company Admin</div>
          </div>
        }

      </div>;
    }
    return contactDisplay;
  }

  createAdminDisplay() {
    let editedCompany = this.copyCompany;
    let adminDisplay = null;
    if (this.state.makeSameChecked) {
      adminDisplay = <div className="admin-display-edit"/>;
    }
    else {
      if (this.state.addAdmin && !this.props.readOnly) {
        adminDisplay = <div className="admin-display-edit">
          <div className="entry-field">
            <div className="label">{this.textMap.firstName.toUpperCase()}</div>
            <Input className="field input-field"
              value={editedCompany.admin && editedCompany.admin.first_name ? editedCompany.admin.first_name : ''}
              onChange={this.handleAdminFirstNameChange} />
          </div>
          <div className="entry-field">
            <div className="label">{this.textMap.lastName.toUpperCase()}</div>
            <Input className="field input-field"
              value={editedCompany.admin && editedCompany.admin.last_name ? editedCompany.admin.last_name : ''}
              onChange={this.handleAdminLastNameChange} />
          </div>
          <div className="entry-field">
            <div className="label">{this.textMap.title.toUpperCase()}</div>
            <Input className="field input-field"
              value={editedCompany.admin && editedCompany.admin.title ? editedCompany.admin.title : ''}
              onChange={this.handleAdminTitleChange} />
          </div>
          <div className="entry-field">
            <div className="label">{this.textMap.phone.toUpperCase()}</div>
            <PhoneInput
              classNameInput={'field input-field'}
              value={editedCompany.admin && editedCompany.admin.phone ? editedCompany.admin.phone : ''}
              handlePhoneChange={this.handleAdminPhoneChange}
            />
          </div>
          <div className="entry-field">
            <div className="label">{this.textMap.email.toUpperCase()}</div>
            <Input className="field input-field"
              value={editedCompany.admin && editedCompany.admin.email ? editedCompany.admin.email : ''}
              onChange={this.handleAdminEmailChange} />
          </div>
          <div className="entry-field markets">
            <div className="label">{'MARKETS'}</div>
            <MarketComboBox 
              markets={this.state.markets} 
              height={26} 
              width={240} 
              hasBorder={false}
              multiSelect={true}                        
              defaultText={'None Selected'}
              handleSelectMarket={this.handleAdminMarketsChange} 
              currentOption={editedCompany.admin ? editedCompany.admin.markets : null} 
            />
          </div>
          <div className="add-user-footer">
            <div className="cancel-button" onClick={this.handleCancelAddAdmin} />
            <div className={'add-button' + (this.isUserValid(editedCompany.admin) ? '' : ' add-button--disabled')} onClick={this.handleAddAdmin}>
              {this.textMap.add.toUpperCase()}
            </div>
          </div>
        </div>;
      }
      else if (this.state.users) {
        const users = this.state.users.filter(user => {
          const companyMatch = user.companies ? user.companies.filter(company => {
            return company.id ? company.id == editedCompany.id : company == editedCompany.id;
          }): [];
          return companyMatch.length > 0;
        });
        let usersList=null;
        if(users){
          usersList=users.filter(function(user){
            return !user.suspended;
          });   
        }  
        let currentAdmin = editedCompany.admin;
        if (currentAdmin.toBeDeleted) {
          currentAdmin = null;
        }
        adminDisplay = <div className="admin-display-edit">
          <div className="entry-field">
            <div className="label">{this.textMap.companyAdmin.toUpperCase()}</div>
            <div className="field input-field">
              {!this.props.readOnly && 
                <SelectUserComboBox 
                  id={'adminPicker'} 
                  width={240} 
                  height={26} 
                  hasBorder={false} 
                  multiSelect={false}
                  handleSelection={this.handleAdminSelection} 
                  currentSelectedUser={currentAdmin}
                  users={usersList} 
                  allowAdd={true}
                  small={true}
                />
              }
              {this.props.readOnly && <div className="field entry-field">{currentAdmin ? currentAdmin.name : 'None Selected'}</div>}
            </div>  
          </div>
        </div>;
      }
    }

    return adminDisplay;
  }

  createColumn1() {

    let editedCompany = this.copyCompany;
    let contactDisplay = this.createContactDisplay();
    let adminDisplay = !editedCompany.is_vendor_company ? this.createAdminDisplay() : null;
    let currentStateOption = {};
    let currentCountry = '';
    if (editedCompany && editedCompany.state) {
      currentStateOption.type = editedCompany.state.toLowerCase();
      currentStateOption.name = editedCompany.state;
      currentCountry = editedCompany.country;
    }

    return <div className="company-crud-column">
        <div className="caption">Basic Information</div>
        <div className="company-info-edit">
          <div className="entry-field">
            <div className="label">
              {this.textMap.companyName.toUpperCase()}
            </div>
            {!this.props.readOnly && <Input className="field input-field" value={editedCompany.name} onChange={this.handleCompanyNameChange} />}
            {this.props.readOnly && <div className="field input-field">{editedCompany.name}</div>}
          </div>
        </div>
        {contactDisplay}
        {adminDisplay}
        <div className='company-location'>
          <div className="entry-field">
            <div className="label">
              {'ADDRESS LINE 1'}
            </div>
            {!this.props.readOnly && <Input className="field input-field" value={editedCompany && editedCompany.address_1 ? editedCompany.address_1 : ''} onChange={this.handleCompanyAddress1Change} />}
            {this.props.readOnly && <div className="field input-field">
                {editedCompany && editedCompany.address_1
                  ? editedCompany.address_1
                  : ''}
              </div>}
          </div>
          <div className="entry-field">
            <div className="label">
              {'ADDRESS LINE 2'}
            </div>
            {!this.props.readOnly && <Input className="field input-field" value={editedCompany && editedCompany.address_2 ? editedCompany.address_2 : ''} onChange={this.handleCompanyAddress2Change} />}
            {this.props.readOnly && <div className="field input-field">
                {editedCompany && editedCompany.address_2
                  ? editedCompany.address_2
                  : ''}
              </div>}
          </div>
          <div className="double-entry-field">
            <div className="half-field input-enabled">
              <div className="label">{this.textMap.city.toUpperCase()}</div>
              <div className="field">
                {!this.props.readOnly && <Input className="field input-field" value={editedCompany && editedCompany.city ? editedCompany.city : ''} onChange={this.handleCompanyCityChange} />}
                {this.props.readOnly && <div className="field input-field">
                    {editedCompany && editedCompany.city
                      ? editedCompany.city
                      : ''}
                  </div>}
              </div>
            </div>
            <div className="half-field input-enabled">
              <div className="label">{this.textMap.state.toUpperCase()}</div>
              <div className="field combo-box">
                {!this.props.readOnly && <StateComboBox defaultText={'STATE/PROVINCE'} currentOption={currentStateOption} handleStateChange={this.handleCompanyStateChange} displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#8B8B8B' }} width={114} height={26} maxHeight={300} top={32} left={0} menuHeight={270} />}
                {this.props.readOnly && <div className="field, input-field">
                    {editedCompany ? editedCompany.state : ''}
                  </div>}
              </div>
            </div>
          </div>
          <div className="double-entry-field">
            <div className="half-field input-enabled">
              <div className="label">{'POSTAL CODE'}</div>
              <div className="field">
                {!this.props.readOnly && <Input className="field input-field" value={editedCompany && editedCompany.zip ? editedCompany.zip : ''} onChange={this.handleCompanyZipChange} />}
                {this.props.readOnly && <div className="field input-field">
                    {editedCompany && editedCompany.zip
                      ? editedCompany.zip
                      : ''}
                  </div>}
              </div>
            </div>
            <div className="half-field input-enabled">
              <div className="label">
                {this.textMap.country.toUpperCase()}
              </div>
              <div className="field combo-box">
                {!this.props.readOnly && <CountryComboBox defaultText={this.textMap.country} currentOption={currentCountry} handleCountryChange={this.handleCompanyCountryChange} displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#8B8B8B' }} width={150} height={32} maxHeight={300} top={32} left={0} />}
                {this.props.readOnly && <div className="field input-field">
                    {editedCompany && editedCompany.country
                      ? editedCompany.country
                      : ''}
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>;
  }

  createMarketsColumn() {
    let editedMarket = this.state.newMarket;
    let readOnly = this.props.readOnly ? true : false;
    let marketsDisplay = this.state.markets ? this.state.markets.map(market =>{
      let marketCode = (            
        <Input className={'field'}
          id={'mc-' + market.id}
          dataId={market.id}
          onChange={this.handleUpdateMarketCodeChange}
          onFocus={this.handleMarketFocus}
          maxLength="4" value={market.code}
          readOnly={readOnly}/>
      ); 
      let marketName = (
        <Input className={'field'}
        id={'mn-' + market.id}
        dataId={market.id}
          onChange={this.handleUpdateMarketNameChange}
          onFocus={this.handleMarketFocus}
          value={market.name}
          readOnly={readOnly}/>
      );
      let saveButton;
      let clearButton = <div className='market-clear' onClick={this.handleDeleteMarket} data-id={market.id}></div>;
      
      if(market.id == this.state.updateMarket.id){
        marketCode = (
          <Input className={'field'}
          id={'mc-' + market.id}
            dataId={market.id}
            dataType='code'
            onFocus={this.handleMarketFocus}
            onChange={this.handleUpdateMarketCodeChange}
            maxLength="4" value={this.state.updateMarket.code}
            ref={(element) => { this.handleSetFocusMarketCode(element); }}
            readOnly={readOnly}
          />
        );
        marketName = (
          <Input className={'field'}
          id={'mn-' + market.id}
          dataId={market.id}
            dataType='name'            
            onFocus={this.handleMarketFocus}
            onChange={this.handleUpdateMarketNameChange}            
            ref={(element) => { this.handleSetFocusMarketName(element); }}
            value={this.state.updateMarket.name}
            readOnly={readOnly}
          />
            
        );
        if(this.state.updateMarketEdited){
          saveButton = (
            <div className={'market-save' + (
              this.state.updateMarket && 
              this.state.updateMarket.code && 
              this.state.updateMarket.name ? 
              ' ' : 
              ' market-save--disabled')
           } 
              onClick={this.state.updateMarketEdited ? this.handleUpdateMarket : undefined}
            >
              {this.textMap.save.toUpperCase()}
            </div>
          );
          clearButton = <div className='market-clear' onClick={this.handleClearUpdateMarket} data-id={market.id}></div>;
        }
      }
      if (this.props.readOnly) {
        saveButton = <div></div>;
        clearButton = <div></div>;
      }

      return(
        <div key={`market-${market.id}`} className='market-container'>
          <div className='quarter-entry-field'>
            <div className='label'>MARKET CODE</div>
            {marketCode}
          </div>
          <div className='three-quarter-entry-field'>            
            <div className='label'>MARKET NAME</div>
            {marketName}
          </div>
          {saveButton}
          {clearButton}
        </div>
      );
    }) : [];
    let newMarket;
    // this.newMarketCode = null
    if(!this.state.updateMarketEdited && !this.props.readOnly){
      newMarket = (
        <div key="market-new" className='market-container'>
          <div className='quarter-entry-field'>
            <div className='label'>MARKET CODE</div>
            <Input className='field' 
              value={editedMarket && editedMarket.code ? editedMarket.code : ''}
              onChange={this.handleNewMarketCodeChange} 
              maxLength="4"
              ref={(element) => {this.newMarketCode = element;}}
            />
          </div>
          <div className='three-quarter-entry-field'>            
            <div className='label'>MARKET NAME</div>
            <Input className='field' value={editedMarket && editedMarket.name ? editedMarket.name : ''} onChange={this.handleNewMarketNameChange}/>
          </div>
          <div className={'market-save' + (
              editedMarket && 
              editedMarket.code && 
              editedMarket.name ?
              '' : 
              ' market-save--disabled')
            } 
            onClick={this.state.marketEdited ? this.handleSaveMarket : undefined}>
            {this.textMap.add.toUpperCase()}
          </div>
          <div className='market-clear' onClick={this.handleClearMarket}></div>                
        </div>
      );
      marketsDisplay.push(newMarket);
    } 

    return <div className="company-crud__market-setup">
        <div className="caption">{this.textMap.marketSetup}</div>
        {marketsDisplay}
      </div>;
  }

  createCustomersColumn() {
    let editedCustomer = this.state.newCustomer;
    let readOnly = this.props.readOnly ? true : false;
    let customersDisplay = this.state.customers ? this.state.customers.map(customer =>{
      let customerCode = (            
        <Input className={'field'}
          dataId={customer.id}
          onChange={this.handleUpdateCustomerCodeChange}
          onFocus={this.handleCustomerFocus}
          maxLength="4" value={customer.code}
          readOnly={readOnly}/>
      ); 
      let customerName = (
        <Input className={'field'}
          dataId={customer.id}
          onChange={this.handleUpdateCustomerNameChange}
          onFocus={this.handleCustomerFocus}
          value={customer.name}
          readOnly={readOnly}/>
      );
      let saveButton;
      let clearButton = <div className='customer-clear' onClick={this.handleDeleteCustomer} data-id={customer.id}></div>;
      
      if(customer.id == this.state.updateCustomer.id){
        customerCode = (
          <Input className={'field'}
            dataId={customer.id}
            dataType='code'
            onFocus={this.handleCustomerFocus}
            onChange={this.handleUpdateCustomerCodeChange}
            maxLength="4" value={this.state.updateCustomer.code}
            ref={(element) => { this.handleSetFocusCustomerCode(element); }}
            readOnly={readOnly}
          />
        );
        customerName = (
          <Input className={'field'}
            dataId={customer.id}
            dataType='name'            
            onFocus={this.handleCustomerFocus}
            onChange={this.handleUpdateCustomerNameChange}            
            ref={(element) => { this.handleSetFocusCustomerName(element); }}
            value={this.state.updateCustomer.name}
            readOnly={readOnly}
          />
            
        );
        if(this.state.updateCustomerEdited){
          saveButton = (
            <div className={'customer-save' + (
              this.state.updateCustomer && 
              this.state.updateCustomer.code && 
              this.state.updateCustomer.name ? 
              ' ' : 
              ' customer-save--disabled')
           } 
              onClick={this.state.updateCustomerEdited ? this.handleUpdateCustomer : undefined}
            >
              {this.textMap.save.toUpperCase()}
            </div>
          );
          clearButton = <div className='customer-clear' onClick={this.handleClearUpdateCustomer} data-id={customer.id}></div>;
        }
      }
      if (this.props.readOnly) {
        saveButton = <div></div>;
        clearButton = <div></div>;
      }

      return(
        <div key={`customer-${customer.id}`} className='customer-container'>
          <div className='quarter-entry-field'>
            <div className='label'>CUSTOMER CODE</div>
            {customerCode}
          </div>
          <div className='three-quarter-entry-field'>            
            <div className='label'>CUSTOMER NAME</div>
            {customerName}
          </div>
          {saveButton}
          {clearButton}
        </div>
      );
    }) : [];
    let newCustomer;
    this.newCustomerCode = null;
    if(!this.state.updateCustomerEdited && !this.props.readOnly){
      newCustomer = (
        <div key="customer-new" className='customer-container'>
          <div className='quarter-entry-field'>
            <div className='label'>CUSTOMER CODE</div>
            <Input className='field' 
              value={editedCustomer && editedCustomer.code ? editedCustomer.code : ''}
              onChange={this.handleNewCustomerCodeChange} 
              maxLength="4"
              ref={(element) => {this.newCustomerCode = element;}}
            />
          </div>
          <div className='three-quarter-entry-field'>            
            <div className='label'>CUSTOMER NAME</div>
            <Input className='field' value={editedCustomer && editedCustomer.name ? editedCustomer.name : ''} onChange={this.handleNewCustomerNameChange}/>
          </div>
          <div className={'customer-save' + (
              editedCustomer && 
              editedCustomer.code && 
              editedCustomer.name ?
              '' : 
              ' customer-save--disabled')
            } 
            onClick={this.state.customerEdited ? this.handleSaveCustomer : undefined}>
            {this.textMap.add.toUpperCase()}
          </div>
          <div className='customer-clear' onClick={this.handleClearCustomer}></div>                
        </div>
      );
      customersDisplay.push(newCustomer);
    } 

    return <div className="company-crud__customer-setup">
        <div className="caption">{this.textMap.customerSetup}</div>
        {customersDisplay}
      </div>;
  }

  handleMaxFileSizeChange(event) {
    const file = event.target.files[0];

    if (file && file.size > this.MAX_SIZE_BYTES) {
      this.props.dataModel.displayInfoErrorMessage(`File is too large. Maximum size is ${this.MAX_SIZE_MB}MB.`, 4000, 4);
      // Optionally clear the input
      event.target.value = '';
      return;
    }
    // Proceed with upload or state update
  }

  createColumn2() {
    let logo, apiWebhooksWidget;
    let editedCompany = this.copyCompany;
    if (editedCompany && editedCompany.logo) {
      if (editedCompany.logo) {
        logo = editedCompany.logo;
      }
      else if (this.state.editedLogo) {
        logo = this.state.editedLogo;
      }
    }
    if(this.props.permissions.isSuperUser == true) {
      apiWebhooksWidget = (
        <div className="api-webhooks">
          <div className="caption">API Webhooks</div>
          <APIKeyWidget apiKey={this.props.company.api_key}/>
        </div>
      );
    }

    // listener for company logo change
    const logoFileInput = document.querySelector('#company-logo-upload input[type="file"]');
    if (logoFileInput) logoFileInput.addEventListener('change', this.handleMaxFileSizeChange);

    return (
      <div className="company-crud-column company-crud-column--customization">
        <div className="company-customization">
          <div className="caption">Customization</div>
          <div className="company-logo-container">
            <div className="label">{'COMPANY LOGO'}</div>
            {
              logo ?
                <div id="company-logo-upload">
                  <img className="company-logo" src={logo} alt='company logo'/>
                   <MultiFileUploader
                    shouldGenerateImagePreview={true}
                    handleFileSelect={this.setCompanyLogo}
                    maximumNumberOfFiles={1}
                    acceptedFileTypes={FileUtil.extensionTypes.photoTypes.split(',')}
                    hideInput={!!logo}
                  />
                  <div className='action-buttons'>
                    <IconButton icon={editIcon} label={'Edit'} onClick={this.handleClickOnUploadLogoInput} />
                    <IconButton icon={deleteIcon} label={'Delete'} onClick={this.deleteCompanyLogo} />
                  </div>
                </div> :
                <MultiFileUploader
                  shouldGenerateImagePreview={true}
                  handleFileSelect={this.setCompanyLogo}
                  maximumNumberOfFiles={1}
                  acceptedFileTypes={FileUtil.extensionTypes.photoTypes.split(',')}
                  hideInput={!!logo}
                />
            }
          </div>
          <div className="company-accent-container">
            <div className="label">{'ACCENT THEME COLOR'}</div>
            <AccentPicker companyAccent={editedCompany.accent_color}
              setCompanyAccent={this.setCompanyAccent} />
          </div>
        </div>
        {apiWebhooksWidget}
      </div>
    );
  }

  render() {
    const { permissions } = this.props;
    const { selectedTabName, editCompany } = this.state;

    if (!editCompany || !permissions) {
      return null;
    }

    let selectedTab;
    switch (selectedTabName) {
    case 'COMPANY INFORMATION':
      const column1 = this.createColumn1();
      const column2 = !editCompany.is_vendor_company && !this.props.readOnly ? this.createColumn2() : null;
      const editedCompany = editCompany;
      const logoAttachment = {
        upload: editedCompany.logo,
      };
      selectedTab = (
          <div className="company-crud-columns">
            {column1}
            {column2}
          </div>
        );
      break;
    case 'COMPANY STRUCTURE':
      const marketsColumn = permissions.canCreateMarkets || permissions.canEditMarkets || permissions.canDeleteMarkets ? this.createMarketsColumn() : null;
      const customersColumn = permissions.canCreateMarkets || permissions.canEditMarkets || permissions.canDeleteMarkets ? this.createCustomersColumn() : null;
      selectedTab = (
          <div className="company-crud__company-structure">
            {marketsColumn}
            {customersColumn}
          </div>
        );
      break;
    case 'ADD-ONS':
      selectedTab = <div className="company-crud__add-ons">
          <CompanyAddOns company={editCompany} />
        </div>;
      break;
    default:
      break;
    }

    return (
      <div id={this.props.id} className={'company-crud' + (this.props.readOnly ? ' company-crud--readonly' : '')}>
        <CompanyHeader 
          company={editCompany} 
          handleExpansion={this.handleExpansion} 
          type='companies-page'
          saveButton={true}
          onSave={this.handleSaveCompany} 
          editCompany={this.state.editing}
          onCancel={this.handleCancel} 
          readOnly={this.props.readOnly}
          companyDeleted={this.props.companyDeleted}
          selectCompany={this.props.selectCompany}
        />
        <TabbedPageControl tabItems={this.tabs} selectedTabName={selectedTabName} handleClick={this.handleSelectTab}/>
        {selectedTab}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
    directories: state.new_directories.directories,
    userRoles: state.new_users.userRoles,
    systemPopup: state.main.systemPopup,
  };
};

export default connect(mapStateToProps)(CompanyCRUD);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompanyCRUD/index.js